export const ROW_HEIGHT = 52;
